jQuery(function ($) {
    var $toggle = $('#menu-toggle');
    var $nav = $('#primary-navigation');
    var $body = $('body');

    if (!$toggle.length || !$nav.length) return;

    function openMenu() {
        $toggle
            .addClass('show')
            .attr('aria-expanded', 'true');

        $nav
            .addClass('show')
            .attr('aria-hidden', 'false');

        $body.addClass('menu-open');
    }

    function closeMenu() {
        $toggle
            .removeClass('show')
            .attr('aria-expanded', 'false');

        $nav
            .removeClass('show')
            .attr('aria-hidden', 'true');

        $body.removeClass('menu-open');
    }

    function toggleMenu() {
        var isOpen = $toggle.hasClass('show');
        isOpen ? closeMenu() : openMenu();
    }

    // Toggle on button click
    $toggle.on('click', function (e) {
        e.preventDefault();
        toggleMenu();
    });

    // Close on ESC (keyboard accessibility)
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $toggle.hasClass('show')) {
            closeMenu();
            $toggle.trigger('focus');
        }
    });

    // Close when clicking outside the nav + toggle
    $(document).on('click', function (e) {
        if (!$toggle.hasClass('show')) return;

        if (
            !$nav.is(e.target) &&
            $nav.has(e.target).length === 0 &&
            !$toggle.is(e.target) &&
            $toggle.has(e.target).length === 0
        ) {
            closeMenu();
        }
    });

    // Initialize ARIA state
    $toggle.attr('aria-expanded', 'false');
    $nav.attr('aria-hidden', 'true');
});
